import { IAppState } from '../reducers';

/** Язык */
export const getLang = (state: IAppState) => state.initialParameters.lang;
/** Домен */
export const getDomain = (state: IAppState) => state.initialParameters.domain;
/** Контентные блоки */
export const getPageBlocks = (state: IAppState) => state.initialParameters.page?.blocks || [];
